import React from "react";
import { Grid } from "@material-ui/core";
import IIntegration from "../../models/IIntegration";
import IntegrationCard from "./IntegrationCard";

export interface IIntegrationListProps {
  integrations: Array<IIntegration>;
  onRequestRefresh: Function;
}

const SortFunc = (a: IIntegration, b: IIntegration): number => {
  if (a.Company && a.Company.Name) {
    if (b.Company && b.Company.Name) {
      const aName = a.Company.Name.toUpperCase();
      const bName = b.Company.Name.toUpperCase();
      if (aName < bName) {
        return -1;
      } else if (aName > bName) {
        return 1;
      }
      return 0;
    }
    return 1;
  }
  return -1;
};

const IntegrationList = (props: IIntegrationListProps) => {
  const { integrations } = props;

  return (
    <Grid container spacing={4}>
      {integrations
        .filter(integration => integration.Company)
        .sort(SortFunc)
        .map(integration => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={integration.ID}>
            <IntegrationCard {...integration} />
          </Grid>
        ))}
    </Grid>
  );
};

export default IntegrationList;
